(() => {
  'use strict';

  function initWorkshopTable(root) {
    if (!root || root.dataset.bbWotReady === 'true') return;
    root.dataset.bbWotReady = 'true';

    const list = root.querySelector('[data-bb-wot-list]');
    const count = root.querySelector('[data-bb-wot-count]');
    const filters = Array.from(root.querySelectorAll('[data-bb-wot-filter]'));
    const preview = root.querySelector('[data-bb-wot-preview]');
    const detailsLinks = Array.from(root.querySelectorAll('[data-bb-wot-details]'));
    const reserveForm = root.querySelector('[data-bb-wot-reserve-form]');
    const reserveVariant = root.querySelector('[data-bb-wot-reserve-variant]');
    const reserveButton = root.querySelector('[data-bb-wot-reserve]');
    const status = root.querySelector('[data-bb-wot-status]');
    const mobileDirectNavigation = window.matchMedia('(max-width: 760px)');
    let rows = list ? Array.from(list.querySelectorAll('[data-bb-wot-row]')) : [];
    let selectedRow = null;

    rows.sort((a, b) => Number(a.dataset.start) - Number(b.dataset.start));
    rows.forEach((row) => list.appendChild(row));

    const primaryMonth = rows[0]?.dataset.month || '';
    const primaryMonthLabel = rows[0]?.dataset.monthLabel || 'Next month';
    const primaryMonthButton = filters.find((button) => button.dataset.bbWotFilter === 'primary-month');
    if (primaryMonthButton) primaryMonthButton.textContent = primaryMonthLabel;

    function matchesFilter(row, filter) {
      if (filter === 'all') return true;
      if (filter === 'primary-month') return row.dataset.month === primaryMonth;
      if (filter === 'under-100') return Number(row.dataset.price) < 10000;
      return row.dataset.style === filter;
    }

    function visibleRows() {
      return rows.filter((row) => !row.hidden);
    }

    function updateCount() {
      if (!count) return;
      const total = visibleRows().length;
      count.textContent = `${total} ${total === 1 ? 'session' : 'sessions'}`;
    }

    function selectRow(row, options = {}) {
      if (!row) return;
      selectedRow = row;

      rows.forEach((candidate) => {
        const selected = candidate === row;
        candidate.classList.toggle('is-active', selected);
        if (selected) candidate.setAttribute('aria-current', 'true');
        else candidate.removeAttribute('aria-current');
      });

      const image = preview?.querySelector('[data-bb-wot-preview-image]');
      const imageBackdrop = preview?.querySelector('[data-bb-wot-preview-backdrop]');
      const title = preview?.querySelector('[data-bb-wot-preview-title]');
      const description = preview?.querySelector('[data-bb-wot-preview-description]');
      const date = preview?.querySelector('[data-bb-wot-preview-date]');
      const price = preview?.querySelector('[data-bb-wot-preview-price]');
      const badge = preview?.querySelector('[data-bb-wot-preview-badge]');

      if (image) {
        image.src = row.dataset.image;
        image.alt = row.dataset.imageAlt || row.dataset.title;
      }
      if (imageBackdrop) imageBackdrop.src = row.dataset.image;
      if (title) title.textContent = row.dataset.title;
      if (description) description.textContent = row.dataset.description;
      if (date) date.textContent = `${row.dataset.date} · ${row.dataset.time}`;
      if (price) price.textContent = row.dataset.priceFormatted;
      if (badge) badge.hidden = row.dataset.newlyAdded !== 'true';
      detailsLinks.forEach((link) => {
        link.href = row.dataset.url;
        link.removeAttribute('aria-disabled');
        if (link.getAttribute('aria-hidden') !== 'true') link.removeAttribute('tabindex');
      });
      if (reserveVariant) reserveVariant.value = row.dataset.variantId;
      if (reserveButton) {
        const soldOut = row.dataset.soldOut === 'true';
        reserveButton.disabled = soldOut;
        reserveButton.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
        reserveButton.textContent = soldOut ? 'Sold Out' : 'Reserve Now';
      }
      if (status && options.announce !== false) {
        const availability = row.dataset.soldOut === 'true' ? 'Sold out.' : 'Available to reserve.';
        status.textContent = `Selected ${row.dataset.title}, ${row.dataset.date}, ${row.dataset.time}, ${row.dataset.priceFormatted}. ${availability}`;
      }
      if (options.focus) row.focus();
    }

    function applyFilter(value, activeButton) {
      rows.forEach((row) => {
        row.hidden = !matchesFilter(row, value);
      });
      filters.forEach((button) => {
        const selected = button === activeButton;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      updateCount();
      const candidates = visibleRows();
      const firstBookable = candidates.find((row) => row.dataset.soldOut !== 'true');
      selectRow(firstBookable || candidates[0]);
    }

    filters.forEach((button) => {
      const value = button.dataset.bbWotFilter;
      if (value !== 'all') {
        button.hidden = !rows.some((row) => matchesFilter(row, value));
      }
      button.addEventListener('click', () => applyFilter(value, button));
    });

    reserveForm?.addEventListener('submit', (event) => {
      if (!reserveVariant?.value || reserveButton?.disabled) event.preventDefault();
    });

    rows.forEach((row) => {
      row.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.detail === 0) return;
        if (mobileDirectNavigation.matches) return;
        const wasSelected = row === selectedRow;
        if (wasSelected) return;
        event.preventDefault();
        selectRow(row);
      });
      row.addEventListener('keydown', (event) => {
        if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].includes(event.key)) return;
        event.preventDefault();
        const candidates = visibleRows();
        const currentIndex = Math.max(0, candidates.indexOf(row));
        const delta = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
        const next = candidates[(currentIndex + delta + candidates.length) % candidates.length];
        selectRow(next, { focus: true });
      });
    });

    if (!rows.length) return;
    root.classList.add('is-enhanced');
    updateCount();
    const firstBookable = rows.find((row) => row.dataset.soldOut !== 'true');
    selectRow(firstBookable || rows[0], { announce: false });
  }

  function initAll(scope = document) {
    if (scope.matches?.('[data-bb-wot]')) initWorkshopTable(scope);
    scope.querySelectorAll?.('[data-bb-wot]').forEach(initWorkshopTable);
  }

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
